
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.602 9.064a.5.5 0 01-.716-.003L1.629 5.695a.5.5 0 01.006-.702l.401-.399a.5.5 0 01.71.004L4.868 6.76a.5.5 0 00.71.004L9.65 2.69a.5.5 0 01.696-.011l.425.4a.5.5 0 01.014.715l-5.183 5.27z","fill":"#fff"}})])
          )
        }
      }
    